import React, {useEffect, useState} from 'react';
import {CheckImg} from "../CheckImg";
import {BASE_URL, FILE_URL} from "../../../config";
import style from './transfer.module.css'

const styles = {
    right: {
        border: '3px solid rgba(128, 253, 195, 0.76)',
    },
    wrongUser: {
        border: '3px solid rgba(253, 128, 128, 0.76)',
    },
}
const TransferAnswer = ({data=[], changeHandler, isPassed}) => {
    const [answerItems, setAnswerItems] = useState([])
    const [visibleAnswerItems, setVisibleAnswerItems] = useState([])
    const [pickedItem, setPickedItem] = useState()
    const [dropZone, setDropZone] = useState([])
    const [isValid,setIsValid] = useState([])



    function shuffle(array = []) {
        const newArray = [...array];
        for (let i = newArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
        }
        return newArray;
    }

    useEffect(() => {
        const newAnswers = data.filter((item, k) => k % 2 !== 0)
        setAnswerItems(newAnswers);
        setVisibleAnswerItems(shuffle(newAnswers))
    }, [data]);

    function muteEvent(e) {
        e.stopPropagation();
        e.preventDefault();
    }

    function onDragStart(e, item) {
        setPickedItem(item)
    }

    function onChangeDrag(e, item) {
        e.stopPropagation();
        e.preventDefault();
        const arr = [...dropZone];
        const index = arr.findIndex((value) => value === pickedItem);
        if (index !== -1) {
            arr[index] = null;
        }
        if (!arr[item]) {
            arr[item] = pickedItem;
        } else {
            const prevValue = arr[item];
            arr[item] = pickedItem;
            setVisibleAnswerItems((prevItems) => [...prevItems, prevValue]);
        }
        setDropZone(arr);
    }

    useEffect(() => {
        if(visibleAnswerItems.length!==0) {
            const arr = visibleAnswerItems.filter((item) => !dropZone.includes(item));
            setVisibleAnswerItems(arr);
            changeHandler(dropZone)
        }
    }, [dropZone])


    const answerWords = visibleAnswerItems.map((item, i) => <div className={style.AnswerWords}
                                                                 key={item + 'key' + i}
                                                                 draggable={!isPassed}
                                                                 onDragStart={e => onDragStart(e, item)}
                                                                 onDragOver={e => muteEvent(e)}
                                                                 onDragEnter={e => muteEvent(e)}
                                                                 onDragLeave={e => muteEvent(e)}
                                                                 onDrop={e => muteEvent(e)
                                                                     // onChangeDrag(e,i )
                                                                 }
    >{item}</div>)

    const getResult = (validAnswer, userAnswer) => {
        const arrIsValid = validAnswer.map((value, index) => value === userAnswer[index]);
        setIsValid(arrIsValid);
    };

    useEffect(()=>{
        if(isPassed){
            getResult(answerItems,dropZone)
        }
    },[isPassed])

    return (
        <>
            <h1 className={style.text}>Элементы для перетаскивания:</h1>
            <div className={style.container}>
                {answerWords}
            </div>
            <div className={style.container}>
                <pre>
                {data.map((item, index) => {
                    if (index % 2 === 0) {
                        const checkImg = CheckImg(item);
                        if (checkImg.length !== 0) {
                            return checkImg.map((element) => {
                                if (element.includes("{!img")) {
                                    return (
                                        <img
                                            src={`${BASE_URL}${FILE_URL}/${element.replace("{!img", "").replace("!}", "")}`}
                                            alt="media"
                                            key={item}
                                        />
                                    );
                                }
                                return element;
                            });
                        }
                        return item;
                    }
                    const dropZoneIndex = Math.trunc(index / 2);
                    const answerFieldText = dropZone[dropZoneIndex] || `Ответ ${dropZoneIndex + 1}`;
                    const isDraggable = !isPassed && dropZone[dropZoneIndex] !== undefined;
                    let answerFieldStyles = {};

                    if (isValid.length > 0) {
                        if (isValid[dropZoneIndex]) {
                            answerFieldStyles = styles.right;
                        } else {
                            answerFieldStyles = styles.wrongUser;
                        }
                    }
                    return (
                        <span
                            className={style.answerFields}
                            draggable={isDraggable}
                            key={item+index}
                            onDragStart={(e) => onDragStart(e, dropZone[dropZoneIndex])}
                            onDragOver={muteEvent}
                            onDragEnter={muteEvent}
                            onDragLeave={muteEvent}
                            onDrop={(e) => onChangeDrag(e, dropZoneIndex)}
                            style={answerFieldStyles}
                        >
                            {answerFieldText}
                         </span>
                    );
                })}
                    </pre>
            </div>
        </>
    )
};

export default TransferAnswer;